export enum CaseActionBuilderName {
  AddToList = 'add_to_list',
  CreateReport = 'create_report',
  UpdateAccount = 'update_account',
  SendSmsOrEmailInquiryLink = 'send_sms_or_email_inquiry_link',
}

export const CaseActionBuilderDecription: Record<
  CaseActionBuilderName,
  { title: string; description: string }
> = {
  [CaseActionBuilderName.AddToList]: {
    title: 'Add to List',
    description:
      'Use this macro to add items such as email address, phone number, and selfie to a list.',
  },
  [CaseActionBuilderName.CreateReport]: {
    title: 'Create Report',
    description: 'Use this macro to run a report such as Watchlist directly from a case.',
  },
  [CaseActionBuilderName.SendSmsOrEmailInquiryLink]: {
    title: 'Send SMS or Email Inquiry Link',
    description:
      'Use this macro to send an inquiry link to an individual via SMS or email directly from a case.',
  },
  [CaseActionBuilderName.UpdateAccount]: {
    title: 'Update Account',
    description: 'Use this macro to quickly update account details from a case.',
  },
};
